import React from "react";
import {
  Footprints, Bike, Waves, Medal, Users, Dumbbell, Activity, PersonStanding,
  Beef, Wheat, Droplet, GlassWater,
} from "lucide-react";

export const SPORT_ICON = {
  run: Footprints, cycle: Bike, swim: Waves, triathlon: Medal,
  team: Users, strength: Dumbbell, walk: PersonStanding, other: Activity,
};

export function SportIcon({ sport, className }) {
  const Icon = SPORT_ICON[sport] || Activity;
  return <Icon className={className} />;
}

export const MACRO_ICON = { protein: Beef, carb: Wheat, fat: Droplet };
export const HYDRATION_ICON = GlassWater;
